























import {Component, Vue} from "vue-property-decorator";
import {namespace} from 'vuex-class';
import TestAlert from "@/components/UI/TestAlert.vue";
import SnackBar from "@/components/UI/SnackBar.vue";

const event = namespace('event')
const alerts = namespace('alerts')


@Component({
  name:'App',
  components: {
    TestAlert,
    SnackBar
  }
})
export default class App extends Vue {
  @event.Getter('shows') protected shows:any
  @alerts.Getter('show') protected show: any
  @alerts.Getter('messages') protected messages: any
  @alerts.Getter('contentClass') protected contentClass: any
  @alerts.Getter('position') protected position: any
  @alerts.Getter('time') protected time: any
  @alerts.Getter('color') protected color: any
  @alerts.Getter('textColor') protected textColor: any
  @alerts.Getter('fontSize') protected fontSize: any




}
